module.exports = __webpack_public_path__ + "static/media/pf15.13f710b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/pf15.png
// module id = 2657
// module chunks = 0